import React, { useContext } from 'react';
import { ProductContext } from '../../../../store';
import DetailSkeleton from '../../../../components/Skeleton/DetailSkeleton';
import MagentoEditSearch from './Magento/EditSearch';
import BigCommerceEditSearch from './BigCommerce/EditSearch';
import ShopifyEditSearch from './Shopify/EditSearch';
import WooCommerceEditSearch from './WooCommerce/EditSearch';
import DrupalEditSearch from './Drupal/EditSearch';

const PLATFORMS = { MAGENTO: "magento", SHOPIFY: "shopify", BIGCOMMERCE: "bigcommerce", WOOCOMMERCE: "woocommerce", DRUPAL: "drupal" };

const getMerchandisingApiConfig = (platform) => {
	const base = platform === PLATFORMS.MAGENTO ? "ms2" : "ms3";
	const prefix = platform === PLATFORMS.MAGENTO ? "merchandising" : platform;
	const path = (endpoint) => `api/v1/${prefix}/${endpoint}`;
	return { base, prefix, path };
};

const EDIT_SEARCH_BY_PLATFORM = {
	[PLATFORMS.MAGENTO]: MagentoEditSearch,
	[PLATFORMS.BIGCOMMERCE]: BigCommerceEditSearch,
	[PLATFORMS.SHOPIFY]: ShopifyEditSearch,
	[PLATFORMS.WOOCOMMERCE]: WooCommerceEditSearch,
	[PLATFORMS.DRUPAL]: DrupalEditSearch,
};

const EditSearch = () => {
	const { currentWebsiteId, websiteData } = useContext(ProductContext);
	const platform = websiteData?.[currentWebsiteId]?.websiteType;
	const apiConfig = platform ? getMerchandisingApiConfig(platform) : null;
	const PageContent = platform ? EDIT_SEARCH_BY_PLATFORM[platform] : null;

	if (!platform || !apiConfig || !PageContent) return <DetailSkeleton />;

	return <PageContent apiConfig={apiConfig} />;
};

export default EditSearch;